<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
                </nav>
            </b-col>
            </b-row>
      </base-header>
    <b-container fluid class="mt--6">
        <b-row>
            <b-col cols="12">
                <b-card>
                    <div slot="header" class="mb-0">
                        <h3>{{language_terms['STOCKCARD_DETAILS']}}</h3>
                    </div>
                    <b-row>
                        <b-col cols="6">
                            <base-input v-model="stockcard.location_name" :label="language_terms['WAREHOUSE']" disabled></base-input>
                        </b-col>
                        <b-col cols="6">
                            <base-input v-model="stockcard.movement_date" :label="language_terms['MOVEMENT_DATE']" disabled></base-input>
                        </b-col>
                        <b-col cols="12">
                            <base-input v-model="stockcard.reference_code" :label="language_terms['REFERENCE']" disabled></base-input>
                        </b-col>
                        <b-col cols="12">
                            <base-input :label="language_terms['REMARKS']" >
                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="stockcard.remarks" disabled></textarea>
                            </base-input>                        
                        </b-col>
                        <b-col sm="12">
                            <h3>{{language_terms['STOCKCARD_ITEMS']}}</h3>
                            <b-table-simple hover responsive class="mt-3">
                                <b-thead head-variant="light">
                                    <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                    <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                    <b-th>{{language_terms['QTY']}}</b-th>
                                    <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                    <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                    <b-th>{{language_terms['LOCATION']}}</b-th>
                                    <b-th>{{language_terms['REMARKS']}}</b-th>
                                </b-thead>
                                <b-tbody>
                                    <tr v-for="(item, index) in stockcard.items" :key="index">
                                        <td>{{item.product_code}}</td>
                                        <td>{{item.product_name}}</td>
                                        <td>{{item.qty}}</td>
                                        <td>{{item.lot_reference}}</td>
                                        <td>{{item.expiry_date}}</td>
                                        <td>{{item.location_name}}</td>
                                        <td>{{item.remarks}}</td>
                                    </tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <base-button icon type="primary" @click="backToList" class="mt-1">
                                {{language_terms['BACK']}}
                            </base-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

export default 
{
    computed:{
        ...mapState({
            language_terms:(state)=>state.languages.language_terms,
            stockcard_data:(state) => state.stockcards.data
        })
    },
    data(){
        return{
            stockcard:{
                movement_date:"",
                location_name:"",
                location_code:"",
                remarks:"",
                items:[]
            }
        }
    },
    async mounted()
    {
        await this.$store.dispatch("stockcards/fetch", {code:this.$route.params.id});
        this.stockcard = this.stockcard_data
    },
    methods:{
        backToList()
        {
            this.$router.go(-1)
        }
    }
}
</script>
